__turbopack_context__.v({
  "controls": "BLp_dG_controls",
  "mobileCloseButton": "BLp_dG_mobileCloseButton",
  "primaryButton": "BLp_dG_primaryButton",
  "root": "BLp_dG_root",
  "secondaryButton": "BLp_dG_secondaryButton",
  "title": "BLp_dG_title",
  "visible": "BLp_dG_visible",
});
